<div class="alert-box">
    <div class="modal-header">
        <button type="button" class="close" (click)="onCancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">
            {{ "publish" | translate }}
        </h4>
    </div>
    <div class="modal-body">
        {{ "invalid_user_tariff_modal_text" | translate }}
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="onCancel()">
            {{ "close" | translate }}
        </button>
    </div>
</div>
